import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { useTranslation } from "@redotech/redo-i18n";
import { memo, useMemo } from "react";
import {
  groupShipmentMessages,
  ShipmentMessages,
} from "../../common/shipment-messages";

export const ShipmentMessagesCard = memo(function ShipmentMessagesCard({
  fulfillmentGroups,
}: {
  fulfillmentGroups: readonly FulfillmentGroupData[];
}) {
  const { t } = useTranslation();
  const groupedMessages = useMemo(
    () =>
      groupShipmentMessages(fulfillmentGroups.map((g) => g.shipmentMessages)),
    [fulfillmentGroups],
  );

  return (
    <ShipmentMessages
      description={t(
        "Errors or warnings generated while retrieving rates for this fulfillment",
      )}
      messagesByCarrier={groupedMessages}
    />
  );
});
